/*** IMPORTS FROM imports-loader ***/
var define = false;

import loadSmoothScrolling from './smoothScrolling'
import loadResponsiveImagesPolyfill from './responsiveImages'
import loadSiteHeader from './siteHeader'
import loadMobileMenu from './mobileMenu'
import loadModals from './modals'
import loadDropdowns from './dropdowns'
import loadBannerVideo from './bannerVideo'
import loadVideoPlayer from './videoPlayer'
import loadIToISlider from './iToISlider'
import loadVisionUnobstructedSlider from './visionUnobstructedSlider'
import loadPartnersFlashingGallery from './partnersFlashingGallery'
import loadShowOnScroll from './showOnScroll'

document.addEventListener('DOMContentLoaded', () => {
    loadSmoothScrolling()
    loadResponsiveImagesPolyfill()
    loadSiteHeader()
    loadMobileMenu()
    loadModals()
    loadDropdowns()
    loadBannerVideo()
    loadVideoPlayer()
    loadIToISlider()
    loadVisionUnobstructedSlider()
    loadPartnersFlashingGallery()
    loadShowOnScroll()
})




// WEBPACK FOOTER //
// ./js/main.js